:host {
  @apply block;
}

:host([grid-cols="1"]) {
  div.grid {
    @apply grid-cols-1;
  }
}

:host([grid-cols="2"]) {
  div.grid {
    @apply grid-cols-2;
  }
}

:host([grid-cols="3"]) {
  div.grid {
    @apply grid-cols-3;
  }
}

:host([grid-cols="4"]) {
  div.grid {
    @apply grid-cols-4;
  }
}

:host([grid-cols="5"]) {
  div.grid {
    @apply grid-cols-5;
  }
}

:host([grid-cols="6"]) {
  div.grid {
    @apply grid-cols-6;
  }
}

:host([grid-cols="7"]) {
  div.grid {
    @apply grid-cols-7;
  }
}

:host([grid-cols="8"]) {
  div.grid {
    @apply grid-cols-8;
  }
}

:host([grid-cols="9"]) {
  div.grid {
    @apply grid-cols-9;
  }
}

:host([grid-cols="10"]) {
  div.grid {
    @apply grid-cols-10;
  }
}

:host([grid-cols="11"]) {
  div.grid {
    @apply grid-cols-11;
  }
}

:host([grid-cols="12"]) {
  div.grid {
    @apply grid-cols-12;
  }
}

:host([sm-grid-cols="1"]) {
  div.grid {
    @apply sm:grid-cols-1;
  }
}

:host([sm-grid-cols="2"]) {
  div.grid {
    @apply sm:grid-cols-2;
  }
}

:host([sm-grid-cols="3"]) {
  div.grid {
    @apply sm:grid-cols-3;
  }
}

:host([sm-grid-cols="4"]) {
  div.grid {
    @apply sm:grid-cols-4;
  }
}

:host([sm-grid-cols="5"]) {
  div.grid {
    @apply sm:grid-cols-5;
  }
}

:host([sm-grid-cols="6"]) {
  div.grid {
    @apply sm:grid-cols-6;
  }
}

:host([sm-grid-cols="7"]) {
  div.grid {
    @apply sm:grid-cols-7;
  }
}

:host([sm-grid-cols="8"]) {
  div.grid {
    @apply sm:grid-cols-8;
  }
}

:host([sm-grid-cols="9"]) {
  div.grid {
    @apply sm:grid-cols-9;
  }
}

:host([sm-grid-cols="10"]) {
  div.grid {
    @apply sm:grid-cols-10;
  }
}

:host([sm-grid-cols="11"]) {
  div.grid {
    @apply sm:grid-cols-11;
  }
}

:host([sm-grid-cols="12"]) {
  div.grid {
    @apply sm:grid-cols-12;
  }
}

:host([md-grid-cols="1"]) {
  div.grid {
    @apply md:grid-cols-1;
  }
}

:host([md-grid-cols="2"]) {
  div.grid {
    @apply md:grid-cols-2;
  }
}

:host([md-grid-cols="3"]) {
  div.grid {
    @apply md:grid-cols-3;
  }
}

:host([md-grid-cols="4"]) {
  div.grid {
    @apply md:grid-cols-4;
  }
}

:host([md-grid-cols="5"]) {
  div.grid {
    @apply md:grid-cols-5;
  }
}

:host([md-grid-cols="6"]) {
  div.grid {
    @apply md:grid-cols-6;
  }
}

:host([md-grid-cols="7"]) {
  div.grid {
    @apply md:grid-cols-7;
  }
}

:host([md-grid-cols="8"]) {
  div.grid {
    @apply md:grid-cols-8;
  }
}

:host([md-grid-cols="9"]) {
  div.grid {
    @apply md:grid-cols-9;
  }
}

:host([md-grid-cols="10"]) {
  div.grid {
    @apply md:grid-cols-10;
  }
}

:host([md-grid-cols="11"]) {
  div.grid {
    @apply md:grid-cols-11;
  }
}

:host([md-grid-cols="12"]) {
  div.grid {
    @apply md:grid-cols-12;
  }
}
